import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import { navLinks, siteMeta } from "../data/siteContent";

function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="site-header">
      <Container>
        <div className="site-header__bar">
          <Link to="/" className="site-brand">
            <img src="/logo.png" alt={`${siteMeta.churchName} logo`} />
            <div>
              <strong>{siteMeta.churchName}</strong>
              <span>{siteMeta.tagline}</span>
            </div>
          </Link>

          <nav className="site-nav site-nav--desktop" aria-label="Primary navigation">
            {navLinks.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `site-nav__link${isActive ? " is-active" : ""}`
                }
                end={item.path === "/"}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="site-header__actions">
            <button
              type="button"
              className={`site-menu-toggle${menuOpen ? " is-open" : ""}`}
              onClick={() => setMenuOpen((value) => !value)}
              aria-label="Open menu"
              aria-expanded={menuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>

        <div className={`site-mobile-panel${menuOpen ? " is-open" : ""}`}>
          <nav className="site-nav site-nav--mobile" aria-label="Mobile navigation">
            {navLinks.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `site-nav__link${isActive ? " is-active" : ""}`
                }
                end={item.path === "/"}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </Container>
    </header>
  );
}

export default SiteHeader;
